import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'CaptureCore',
  brandName: 'CaptureCore',
  description: 'Sistema de agendamento para fotógrafos',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Estúdio fotográfico profissional',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Fotógrafo em sessão com cliente',
  },
  testimonials: [
    {
      name: 'Laura Santos',
      role: 'Fotógrafa de Casamentos',
      text: 'O CaptureCore ajudou-me a organizar todas as minhas sessões e reuniões com noivos. Essencial!',
      image: testimonial1,
    },
    {
      name: 'Pedro e Ana',
      role: 'Clientes',
      text: 'Marcar a sessão de fotos foi super simples. Adorámos a experiência e o profissionalismo.',
      image: testimonial2,
    },
    {
      name: 'Click Studios',
      role: 'Estúdio de Fotografia',
      text: 'Gerir vários fotógrafos e sessões em simultâneo tornou-se muito mais fácil com este sistema.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'fotógrafo',
    professionals: 'fotógrafos',
    business: 'estúdio',
    businesses: 'estúdios',
    service: 'sessão',
    services: 'sessões',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Fotografia Profissional',
      title: 'Capture momentos únicos com CaptureCore',
      description: 'Organize suas sessões fotográficas e crie memórias inesquecíveis com o CaptureCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '270+', label: 'Fotógrafos' },
      { value: '19k+', label: 'Sessões Realizadas' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Sessões Sobrepostas',
        description: 'Gerir múltiplos tipos de sessões com diferentes durações causa conflitos na agenda.',
        icon: 'Camera',
        quote: {
          text: 'Antes do CaptureCore já marquei casamento e batizado no mesmo horário, foi um caos',
          author: 'Miguel Ferreira',
          business: 'Ferreira Photography',
        },
      },
      {
        title: 'Briefings Incompletos',
        description: 'Sem informações detalhadas sobre a sessão, é difícil preparar equipamento e conceito adequados.',
        icon: 'FileText',
        stats: [
          { label: 'Sessões mal preparadas:', value: '30%' },
          { label: 'Tempo perdido em replanificação:', value: '10h/semana' },
        ],
      },
      {
        title: 'Gestão de Portfólio',
        description: 'Mostrar trabalhos anteriores por WhatsApp ou email é pouco profissional e ineficiente.',
        icon: 'Image',
        quote: {
          text: 'Com o portfólio digital os clientes escolhem o estilo que querem antes da sessão',
          author: 'Carolina Dias',
          business: 'C.D. Visual Stories',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'CaptureCore: O seu estúdio digital',
      description: 'Tecnologia criativa para fotógrafos que valorizam arte e profissionalismo.',
      features: [
        {
          title: 'Agendamento por Tipo',
          description: 'Diferentes tipos de sessão (casamento, batizado, corporativo) com durações específicas.',
        },
        {
          title: 'Briefing Detalhado',
          description: 'Clientes preenchem questionário completo sobre estilo, localização e expectativas.',
        },
        {
          title: 'Portfólio Interativo',
          description: 'Apresente seu trabalho profissionalmente e permita clientes explorarem estilos diferentes.',
        },
      ],
    },
    testimonials: {
      title: 'O que os fotógrafos dizem',
      description: 'Fotógrafos que elevaram seu profissionalismo com o CaptureCore.',
    },
    finalCta: {
      title: 'Pronto para capturar mais momentos?',
      description: 'Junte-se aos fotógrafos que já organizaram sua arte com o CaptureCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de fotógrafo',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
